/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import { MultipleAuthorTemplate } from "../multi-author";
import { getAuthorNameKeyword, getDevider } from "../utils";

import "./hero-overlay-multi-author.m.css";

export function HeroOverlayMultiAuthorTemplate(props) {
  const lowPhotoPriorityPropsObj = Object.assign({}, props, {
    authorNameKeyword: getAuthorNameKeyword(),
    storyPubKeyword: getDevider(),
    hideImage: true
  });

  return (
    <div styleName="hero-overlay-multi-author">
      <MultipleAuthorTemplate {...lowPhotoPriorityPropsObj} />
    </div>
  );
}
